import React from 'react';
import { rootSelector } from '../../../common/selectors/selectors';

const DuoMfaDialog: React.FC = () => {
  const systemLogin = rootSelector(state => state.login.loginSuccess);

  React.useEffect(() => {
    if (systemLogin.mfaRequired && systemLogin.useDuoMfa && systemLogin.duoAuthUrl) {
      // Redirect browser to Duo Universal Prompt
      window.location.href = systemLogin.duoAuthUrl;
    }
  }, [systemLogin]);

  return null;  // Component doesn't render UI, just triggers redirect
};

export default DuoMfaDialog;
